import { getTokenExpiry } from "./jwt";
import * as api from "..";
import { storageHelper } from "../../storage";

// const appleLoginApi = async (variables: api.AppleLoginInput) => {
//   const client = new api.Token_Client(undefined, api.publicApiClient);

//   const response = await client.token_LoginWithApple(variables);

//   if (response.succeeded && response.data) {
//     return response.data;
//   }

//   return {};
// };

// const verifyOTPApi = async (variables: api.VerifyOTPInput) => {
//   const client = new api.Token_Client(undefined, api.publicApiClient);

//   const response = await client.token_VerifyOTP(variables);

//   if (response.succeeded && response.data) {
//     return response.data;
//   }

//   return {};
// };

// const sendOTPApi = async (variables: api.SendOTPInput) => {
//   const client = new api.Token_Client(undefined, api.publicApiClient);

//   const response = await client.token_SendOTP(variables);

//   if (!response.succeeded) {
//     throw new Error(response.messages?.join(', ') ?? 'Error sending OTP');
//   }
// };

const refreshTokenApi = async (variables: api.Server.RefreshTokenV2Input) => {
  try {
    const client = new api.Server.Server_Account_Client(
      undefined,
      api.publicApiClient
    );

    const response = await client.account_token_refresh_post_V2(variables);

    if (response.success && response.data) {
      return response.data;
    }

    return {};
  } catch (error: any) {
    console.log("refreshTokenApi", { ...error });
    console.log("refreshTokenApi", error?.response);
    return {};
  }
};

// export const appleLogin = async (variables: api.AppleLoginInput) => {
//   try {
//     diagnosticEvents.log('Apple Login - Token Helper');
//     const data = await appleLoginApi(variables);

//     return await saveThenReturnTokenData(data);
//   } catch (error: any) {
//     diagnosticEvents.recordError(error, 'Apple Login Error - Token Helper');
//     // const data = handleError(error, 'publicSearchKits');
//     // if (data) return rejectWithValue(data);
//     console.log(error);
//     throw error;
//   } finally {
//   }
// };

// export const sendOTP = async (variables: api.SendOTPInput) => {
//   try {
//     diagnosticEvents.log('Send OTP - Token Helper');
//     const data = await sendOTPApi(variables);

//     return data;
//   } catch (error: any) {
//     diagnosticEvents.recordError(error, 'Send OTP Error - Token Helper');
//     // const data = handleError(error, 'publicSearchKits');
//     // if (data) return rejectWithValue(data);
//     console.log(error);
//     throw error;
//   } finally {
//   }
// };

// export const verifyOTP = async (variables: api.VerifyOTPInput) => {
//   try {
//     diagnosticEvents.log('Verify OTP - Token Helper');
//     const data = await verifyOTPApi(variables);

//     return await saveThenReturnTokenData(data);
//   } catch (error: any) {
//     console.log(error);
//     diagnosticEvents.recordError(error, 'Verify OTP Error - Token Helper');
//     // const data = handleError(error, 'publicSearchKits');
//     // if (data) return rejectWithValue(data);
//     throw error;
//   } finally {
//   }
// };

export const refreshToken = async (
  variables: api.Server.RefreshTokenV2Input
) => {
  try {
    const data = await refreshTokenApi(variables);

    return await saveThenReturnAuthData(data, true);
  } catch (error: any) {
    // const data = handleError(error, 'publicSearchKits');
    // if (data) return rejectWithValue(data);
    console.log("refreshToken", error);
    throw error;
  } finally {
  }
};

export const getSavedToken = async () => {
  try {
    const data = await storageHelper.getStorage("TOKEN");

    return data;
  } catch (error: any) {
    // const data = handleError(error, 'publicSearchKits');
    // if (data) return rejectWithValue(data);
    console.log(error);
    throw error;
  } finally {
  }
};

export const loadSavedAuth = async () => {
  try {
    const token = await storageHelper.getStorage("TOKEN");
    const user = await storageHelper.getStorage("USER");

    return {
      ...token,
      ...user,
    };
  } catch (error: any) {
    // const data = handleError(error, 'publicSearchKits');
    // if (data) return rejectWithValue(data);
    console.log(error);
    throw error;
  } finally {
  }
};

export const removeToken = async () => {
  try {
    await storageHelper.removeStorage("TOKEN");
  } catch (error: any) {
    // const data = handleError(error, 'publicSearchKits');
    // if (data) return rejectWithValue(data);
    console.log(error);
    throw error;
  } finally {
  }
};

export async function saveThenReturnAuthData(
  data: api.Server.AuthenticateOutput,
  tokenOnly = false
) {
  if (!data.token || !data.refreshToken) throw new Error("Invalid Token");

  const expiry = getTokenExpiry(data.token);

  await storageHelper.setStorage({
    key: "TOKEN",
    data: {
      refreshToken: data.refreshToken,
      token: data.token,
      expiry,
    },
  });

  if (!tokenOnly) {
    await storageHelper.setStorage({
      key: "USER",
      data: {
        onboardingCompleted: Boolean(data.onboardingCompleted),
      },
    });
  }

  return data;
}
